import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

export type ConsultationDraftContext = 'prescription' | 'pre_consultation';

export interface ConsultationDraftQuery {
  context_type: ConsultationDraftContext;
  appointment_id?: number | null;
  patient_id?: number | null;
  patient_selected_from_search?: boolean;
}

export interface ConsultationDraftClearQuery {
  context_type: ConsultationDraftContext;
  appointment_id?: number | null;
  patient_id?: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class ConsultationDraftService {
  private apiUrl: string;

  constructor(private http: HttpClient, private apiService: ApiService) {
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`
      })
    };
  }

  getDraft(query: ConsultationDraftQuery): Observable<any> {
    let params = new HttpParams().set('context_type', query.context_type);

    if (query.appointment_id) {
      params = params.set('appointment_id', String(query.appointment_id));
    }
    if (query.patient_id) {
      params = params.set('patient_id', String(query.patient_id));
    }
    if (query.patient_selected_from_search) {
      params = params.set('patient_selected_from_search', '1');
    }

    return this.http.get(`${this.apiUrl}/consultation-drafts`, {
      ...this.getAuthHeaders(),
      params
    });
  }

  saveDraft(query: ConsultationDraftQuery, payload: Record<string, unknown>): Observable<any> {
    return this.http.put(`${this.apiUrl}/consultation-drafts`, {
      ...query,
      payload
    }, this.getAuthHeaders());
  }

  clearDraft(query: ConsultationDraftClearQuery): Observable<any> {
    let params = new HttpParams().set('context_type', query.context_type);

    if (query.appointment_id) {
      params = params.set('appointment_id', String(query.appointment_id));
    }
    if (query.patient_id) {
      params = params.set('patient_id', String(query.patient_id));
    }

    return this.http.delete(`${this.apiUrl}/consultation-drafts`, {
      ...this.getAuthHeaders(),
      params
    });
  }
}
